import axios from 'axios'

const state = {
  permissions: [],
}

const getters = {
  getPermissions (state) {
    return state.permissions
  },
}

const mutations = {
  setPermissions (state, payload) {
    state.permissions = payload
  },
}

const actions = {
  fetchPermissions ({ commit, rootGetters }, meta) {
    return axios
      .get(
        `${rootGetters['api/permissions']}?limit=${meta.limit}&offset=${meta.offset}&page=${meta.page}`,
      )
      .then((res) => {
        commit('setPermissions', res.data.items)

        return res
      })
      .catch((err) => err)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
